import { useMemo } from 'react';
import { AssignmentTypeEnum, CaseTypeEnum } from 'api/model';
import useIsExcludedFromFullöDayPlanning from './useHasTestAccessToPlaceholderCases';

// Get all available assignment type options (numbers only)
export const allAssignmentTypeOptions: AssignmentTypeEnum[] = Object.values(
  AssignmentTypeEnum
).filter((s) => typeof s === 'number') as AssignmentTypeEnum[];

interface UseAssignmentTypeOptionsParams {
  currentCaseType?: CaseTypeEnum;
  onlyPersonalTransport?: boolean;
}

const useAssignmentTypeOptions = ({
  onlyPersonalTransport = false,
  currentCaseType,
}: UseAssignmentTypeOptionsParams): AssignmentTypeEnum[] => {
  const hasTestAccessToPlaceholderCases = useIsExcludedFromFullöDayPlanning();

  return useMemo(() => {
    return allAssignmentTypeOptions.filter((v) => {
      // Raderna för personlig transport nås av alla med
      // UsersWithAccessToInEditStopOvers — typlistan ska därför inte
      // begränsas av placeholder-testflaggan.
      if (onlyPersonalTransport) {
        return (
          [
            AssignmentTypeEnum.GoByBoat,
            AssignmentTypeEnum.GoByTrain,
            AssignmentTypeEnum.GoByPlane,
            AssignmentTypeEnum.GoByBus,
            AssignmentTypeEnum.GoByTaxi,
            AssignmentTypeEnum.GoByPublicTransport,
          ] as AssignmentTypeEnum[]
        ).includes(v);
      }
      switch (v) {
        case AssignmentTypeEnum.CarPlaceholder:
          return currentCaseType === CaseTypeEnum.Placeholder; // only show for placeholder cases

        case AssignmentTypeEnum.GoByBoat:
        case AssignmentTypeEnum.GoByTrain:
        case AssignmentTypeEnum.GoByPlane:
        case AssignmentTypeEnum.GoByBus:
        case AssignmentTypeEnum.GoByTaxi:
        case AssignmentTypeEnum.GoByPublicTransport:
          return (
            hasTestAccessToPlaceholderCases &&
            currentCaseType !== CaseTypeEnum.Placeholder
          );

        default:
          return currentCaseType !== CaseTypeEnum.Placeholder; // show the rest only for non-placeholder cases
      }
    });
  }, [currentCaseType, hasTestAccessToPlaceholderCases, onlyPersonalTransport]);
};

export default useAssignmentTypeOptions;
